import { Observable } from 'rxjs/Rx';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { ToasterService, ToasterConfig, Toast } from 'angular2-toaster';
import * as moment from 'moment';
import { Injectable } from '@angular/core';

let config = require('../../config').appConfig;

@Injectable()
export class BaseService {

public toasterService: ToasterService;
private http: Http;
  constructor(http: Http, toasterService: ToasterService)
  {
    this.http = http;
    this.toasterService = toasterService;
    // this.toasterService = new ToasterService();
    // this.http = new Http()
      
  }

  

  public handleError(error: any) {
    var applicationError = error.status;

    // either applicationError in header or model error in body
    if (applicationError == 400) {
      //return Observable.throw(applicationError);
      var toast: Toast = {
        type: 'error',
        title: "Error",
        body: error._body
      };
      this.toasterService.pop(toast);
    }

    
    return Observable.throw(error || 'Server error');
  }

  getLocalTimeFromUtc(serverDateTime: Date) {

    var offset = moment().utcOffset();
    //.format('llll')
    return moment.utc(serverDateTime).utcOffset(offset).format('llll');
  }

  

  getEpochTime(date: Date) {
    return moment(date).unix();
  }

  isBeforeNow(date: Date) {
    var now = moment();
    return !moment(date).isAfter(now);
  }

  
  sendHttpGet(url: string, params?: any): Observable<any> {

    let options = this.sendHttp(url, params)     
    return this.http.get(config.apiRoute + url,  options)
      .map(response => response.json())
      .catch(this.handleError);
  }

  sendHttpPost(url: string, value: any): Observable<any> {
    let options = this.sendHttp(url);
    return this.http.post(config.apiRoute + url, value, options)
      .map(response => response.json())
      .catch(error => this.handleError(error));
  }

  private sendHttp(url: string, params?: any): RequestOptions {
    let headers = new Headers();
    // let sendParams: URLSearchParams = new URLSearchParams();
    // for (var key in params) {
    //     if (params.hasOwnProperty(key))
    //     sendParams.append(key, params[key]);
    // }
    
    headers.append('Content-Type', 'application/json');
    let authToken = localStorage.getItem('token');
    headers.append('Authorization', `Bearer ${authToken}`);

    let options = new RequestOptions({headers: headers, params: params});
    return options;
  }

  
}



// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/services/base.service.ts